// Eyebrow + title (last part in red) + optional intro, shared by every section.
const SectionHeader = ({ eyebrow, title, accent, intro }) => (
  <div className="ee-head" data-aos="fade-up" data-aos-once="true">
    <span className="ee-eyebrow">{eyebrow}</span>
    <h2 className="ee-title">
      {title} <span>{accent}</span>
    </h2>
    {intro && <p className="ee-intro">{intro}</p>}
  </div>
);

export default SectionHeader;
